export enum SyncstepId {
    Import_HR = 1,
    Import_AD = 2,
    Import_AD_2 = 3,
    Import_Hierachy = 4,
    Synchronization = 5,
    Export_AD = 6,
    Import_AD_Results = 7,
    Export_AD2 = 8,
    Import_AD_Results_2 = 9,
    Export_HR = 10,
    Office365 = 11,
    Import_Office365_Results = 12,
    ImportHrFuture = 13,
    ImportSAS = 14,
    ExportCanvas = 15,
    Export_P360 = 1014,
    Export_P3602 = 1015,
    Export_WinTid = 1016,
    ExportWebCruiter = 1017,
    ImportHR2 = 1018,
    ImportHierachy2 = 1019,
    ImportHrFuture2 = 1020,
    ImportHR3 = 1093,
    ImportHierachy3 = 1094,
    Export_Acos = 1021,
    Export_Agresso = 1022,
    Export_Compilo = 1023,
    Export_Dossier = 1024,
    Export_P360_Arkiv = 1025,
    Export_Azure = 1026,
    Export_Visma = 1027,
    Export_NetPower = 1028,
    Export_SikriElements = 1029,
    Export_KSFiks = 1030,
    Export_Motivati = 1031,
    Export_Helseplatform = 1032,
    Export_KS_Laering = 1033,
    Export_Form_to_eAdm = 1034,
    Export_Compilo2 = 1035,
    Export_eHub_to_eAdm_Permissions = 1036,
    Export_eFeide = 1037,
    Export_EQS = 1038,
    Export_XLedger = 1039,
    Export_CatalystOne = 1040,
    Export_Moodle = 1041,
    Export_Framsikt = 1042,
    Export_Prokom = 1044,
    Export_Google = 1045,
    Import_Xledger_HR = 1046,
    Export_CIM = 1047,
    Import_Xledger_HI = 1048,
    Export_SDWorx = 1049,
    Export_ARX = 1050,
    Ad3 = 1051,
    Export_Visma_Connect = 1052,
    Export_Gerica = 1053,
    Execute_Script = 1054,
    Execute_Script_2 = 1055,
    Execute_Script_3 = 1056,
    Execute_Script_4 = 1057,
    Execute_Script_5 = 1058,
    Start_Cycle = 1059,
    Export_TechStep = 1060,
    Export_AFAS = 1061,
    Export_TQM = 1062,
    Export_Agresso_2 = 1063,
    Export_Acos_2 = 1064,
    Export_Simployer = 1065,
    Export_Azure_2 = 1066,
    Export_Flat_file = 1067,
    Export_eFeide_Merge = 1068,
    Export_Quinyx = 1069,
    Export_Moodle_2 = 1070,
    Export_Moodle_3 = 1071,
    Export_Moodle_4 = 1072,
    Export_Sikri_Elements_2 = 1073,
    Export_Sikri_Elements_3 = 1074,
    Export_Sikri_Elements_4 = 1075,
    Export_Tamigo = 1076,
    Export_QM_Plus = 1077,
    Import_Generic_File = 1078,
    Export_Generic_File = 1079,
    Import_Generic_File2 = 1080,
    Import_Generic_File3 = 1081,
    Export_Generic_File2 = 1082,
    Export_Generic_File3 = 1083,
    Export_Moodle_5 = 1084,
    Export_Mepco = 1085,
    Import_AD_Results_3 = 1104,
    Export_AD4 = 1107,
    Import_AD_Results_4 = 1108,
    Export_AD5 = 1109,
    Import_AD_Results_5 = 1110,
    Export_AD6 = 1111,
    Import_AD_Results_6 = 1112,
    Export_AD7 = 1113,
    Import_AD_Results_7 = 1114,
    Export_AD8 = 1115,
    Import_AD_Results_8 = 1116,
    Export_AD9 = 1117,
    Import_AD_Results_9 = 1118,
    Export_Oracle_HCM = 1119,
    Export_Aidn = 1102,
    Export_Aidn_2 = 1120,
    Export_Aidn_3 = 1121,
    Export_Aidn_4 = 1122,
    Export_Aidn_5 = 1123,
    Export_Aidn_6 = 1124,
    Export_Aidn_7 = 1125,
    Export_Aidn_8 = 1126,
    Export_Aidn_9 = 1127,
}
